import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)

class Ticketing {
  constructor() {
    this.button = document.querySelector('.js-ticketing-btn')
    this.section = document.querySelector('.js-ticketing-section')

    this.init()
  }

  init() {
    this.onClick()
  }

  onClick() {
    this.button?.addEventListener('click', () => {
      gsap.to(window, { duration: 0.7, scrollTo: { y: this.section }, ease: 'power2.out' })
    })
  }
}

export default Ticketing
